import superagent from 'superagent'

export const fetchAssignedSubscriptionAction = (payload) => ({
  type: 'FETCH_ASSIGNED_SUBSCRIPTION',
  payload: payload
})

export const fetchAssignedSubscription = (userSubId) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/UserSubscription/Assigned?userSubId=${userSubId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status === 401) {
            resolve(401); // Handle unauthorized
          } else {
            reject(err); // Handle other errors
          }
        } else {
          dispatch(fetchAssignedSubscriptionAction(res.body))
          resolve(res.body); // Success
        }
      });
  });
}


export const cancelAssignedSubscription = ({ userId, userSubId }) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    // https://staging-api.basemap.com/api/v1/UserSubscription/Cancel
    superagent
      // .delete(`${__API_URI__}/UserSubscription/Cancel?userPlanId=${userPlanId}`)
      // .delete(`${__API_URI__}/UserSubscription/Cancel`)
      .delete(`${__API_URI__}/UserSubscription/Reject`)
      .set('Authorization', `Bearer ${token}`)
      .query({ userSubId }) // sends ?userId=...&userSubId=...
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status === 401) {
            reject(401); // Handle unauthorized
          } else {
            reject(err); // Handle other errors
          }
        } else {
          resolve(res.body); // Success
        }
      });
  });
}


